export default class CreateIntegrationRequest  {
	integrationSystemId = '';
}